import { render, staticRenderFns } from "./formulir_kependudukan.vue?vue&type=template&id=a909853c&"
import script from "./formulir_kependudukan.vue?vue&type=script&lang=js&"
export * from "./formulir_kependudukan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports